import { Component, HostListener, OnDestroy } from '@angular/core';
import { LanguageInterface } from '@mzima-client/sdk';
import { LanguageService } from '@services';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss'],
})
export class LanguageComponent implements OnDestroy {
  languages$: Observable<LanguageInterface[]>;
  selectedLanguage$: Observable<string>;
  isRTL$: Observable<boolean>;
  isDropdownOpen = false;
  private subscription: Subscription = new Subscription();

  constructor(private languageService: LanguageService) {
    this.languages$ = this.languageService.languages$;
    this.selectedLanguage$ = this.languageService.selectedLanguage$;
    this.isRTL$ = this.languageService.isRTL$;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLanguage(code: string) {
    this.languageService.changeLanguage(code);
    this.isDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const isInsideDropdown = clickedElement.closest('.language-selector');

    if (!isInsideDropdown && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }
}
